import { z } from "zod";
import { Button, Grid, TextInput } from "@monolith-forensics/monolith-ui";
import ButtonMenu from "./components/ButtonMenu.js";
import { useForm, zodResolver } from "@mantine/form";
import diffFormData from "./utils/diffFormData.js";

const DefaultQaChecklistForm = ({
  defaultFormData = {},
  buttonProps = {},
  onSubmit,
  onCancel,
}) => {
  // Validation schema
  const schema = z.object({
    checklist_name: z.string().nonempty(),
  });

  const form = useForm({
    mode: "uncontrolled",
    initialValues: defaultFormData,
    validate: zodResolver(schema),
  });

  const handleSubmit = async () => {
    const validateResult = form.validate();

    if (validateResult.hasErrors) {
      return;
    }

    const formData = form.getValues();

    const diffData = diffFormData(defaultFormData, formData);

    // call onSubmit with modeled data and diff data
    // diff data is used when the form is in edit context
    // diff may be used when we only want to update modified values
    onSubmit?.(formData, diffData);
  };

  const handleCancel = () => {
    form.reset();
    onCancel?.();
  };

  return (
    <>
      <Grid col={1} style={{ marginBottom: 10 }}>
        <TextInput
          size="sm"
          variant="outlined"
          label="Checklist Name"
          placeholder="Enter checklist name"
          required
          description={
            "This is the name of your checklist. This will be used to identify the checklist in the system."
          }
          key={form.key("checklist_name")}
          {...form.getInputProps("checklist_name")}
        />
      </Grid>
      <ButtonMenu>
        <Button size="xs" variant="subtle" onClick={handleCancel}>
          {buttonProps.cancelText || "Cancel"}
        </Button>
        <Button
          size="xs"
          color="primary"
          variant="contained"
          onClick={handleSubmit}
        >
          {buttonProps.submitText || "Submit"}
        </Button>
      </ButtonMenu>
    </>
  );
};

export default DefaultQaChecklistForm;
